export default (milliseconds: number) =>
    new Promise(resolve =>
        setTimeout(() => {
            resolve();
        }, milliseconds)
    );
